module.exports = __webpack_public_path__ + "img/mfd_in_2_thum.81f564d3.png";